import {
  AddressText,
  AssetFeatures,
  AssetProfileContainer,
  AssetProfileFeatureContainer,
  AssetProfileInfo,
  AssetProfileLabel,
  AssetProfileValue,
  CadastralRefContainer,
  CadastralRefText,
  Description,
  FeatureCell,
  LocationAdmins,
  Separator,
} from './assetReportProfile.styles';
import { AssetProfileMaps } from './assetProfileMaps.component';
import { HalfPageModule } from '../../../styles/global.styles';
import {
  AssetConditionIconDictionary,
  AssetDetailsIconDictionary,
  AssetFeaturesIconDictionary,
} from '../../../helpers/dictionaries.helper';
import { FormattedMessage } from 'react-intl';
import { AssetProfileDataModel } from '../../../types/assetProfile.interface';
import { isNaN } from 'lodash';
import { useIntl } from 'react-intl';

export function AssetProfile(props: AssetProfileDataModel) {
  const defaultLocation = {
    lat: props.lat,
    lng: props.lon,
  };
  const intl = useIntl();
  const sqmSuffix2 = intl.formatMessage({ id: 'sqmSuffix' });

  return (
    <HalfPageModule>
      <AssetProfileContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {props && props.address && (
            <AddressText>
              {' '}
              {props.address.length > 67
                ? `${props.address.slice(0, 67)}...`
                : props.address}
            </AddressText>
          )}
          <LocationAdmins>
            {props && props.locationAdmins ? (
              props.locationAdmins.map((name) => name.toUpperCase()).join(', ')
            ) : (
              <>
                {props && props.neighborhood && props.neighborhood.toUpperCase()},{' '}
                {props && props.district && props.district.toUpperCase()},{' '}
                {props && props.city && props.city.toUpperCase()}
              </>
            )}
          </LocationAdmins>
          {props && props.cadastralRef !== null && (
            <CadastralRefContainer>
              <AssetProfileValue>
                <FormattedMessage id="profile.cadastralRef" />
              </AssetProfileValue>
              <CadastralRefText>{props.cadastralRef}</CadastralRefText>
            </CadastralRefContainer>
          )}
        </div>
        <AssetProfileInfo>
          <AssetProfileFeatureContainer>
            <AssetProfileLabel>
              <FormattedMessage
                id={'propertyType'}
                defaultMessage={'Subtipología'}
              />
            </AssetProfileLabel>
            <AssetProfileValue>
              {props && props.propertyType ? (
                <FormattedMessage id={`subtypology.${props.propertyType}`} />
              ) : (
                '-'
              )}
            </AssetProfileValue>
          </AssetProfileFeatureContainer>
          <Separator />
          <AssetProfileFeatureContainer>
            <AssetProfileLabel>
              <FormattedMessage id="area" />
            </AssetProfileLabel>
            <AssetProfileValue>
              {props && props.area} {sqmSuffix2}
            </AssetProfileValue>
          </AssetProfileFeatureContainer>
          {props && props.parcelArea && props.parcelArea > 0 ? (
            <AssetProfileFeatureContainer>
              <AssetProfileLabel>
                <FormattedMessage id="parcelArea" />
              </AssetProfileLabel>
              <AssetProfileValue>
                {props.parcelArea} {sqmSuffix2}
              </AssetProfileValue>
            </AssetProfileFeatureContainer>
          ) : (
            <Separator />
          )}
          {!(
            (props.listingType === 8 || props.listingType === 12) &&
            (props.reportType === 2 || props.reportType === 3)
          ) && (
            <AssetProfileFeatureContainer>
              <AssetProfileLabel>
                <FormattedMessage id={`constructionYear`} />
              </AssetProfileLabel>
              {props && props.yearBuilt ? (
                <AssetProfileValue>
                  {props && props.yearBuilt}
                </AssetProfileValue>
              ) : (
                <AssetProfileValue>-</AssetProfileValue>
              )}
            </AssetProfileFeatureContainer>
          )}
          <Separator />
          {!(
            (props.listingType === 8 || props.listingType === 12) &&
            (props.reportType === 2 || props.reportType === 3)
          ) && (
            <AssetProfileFeatureContainer>
              <AssetProfileLabel>
                <FormattedMessage id="floor" />
              </AssetProfileLabel>
              <AssetProfileValue>
                {AssetDetailsIconDictionary.floor}
                {props.floor !== undefined && props.floor !== null
                  ? props.floor + 'º'
                  : '-'}
              </AssetProfileValue>
            </AssetProfileFeatureContainer>
          )}
          {props.listingType === 1 && (
            <AssetProfileFeatureContainer>
              <AssetProfileLabel>
                <FormattedMessage id="rooms" />
              </AssetProfileLabel>
              <AssetProfileValue>
                {AssetDetailsIconDictionary.bedrooms}
                {props.rooms ? props.rooms : '-'}
              </AssetProfileValue>
            </AssetProfileFeatureContainer>
          )}
          {props.listingType === 1 && (
            <AssetProfileFeatureContainer>
              <AssetProfileLabel>
                <FormattedMessage id="bathrooms" />
              </AssetProfileLabel>
              <AssetProfileValue>
                {AssetDetailsIconDictionary.bathrooms}
                {props.nbaths ? props.nbaths : '-'}
              </AssetProfileValue>
            </AssetProfileFeatureContainer>
          )}
        </AssetProfileInfo>
        <AssetFeatures>
          {props && props.buildStatus && (
            <FeatureCell backgroundcolor="#BCDBD9" color="#0E504C">
              {
                AssetConditionIconDictionary[
                  props.buildStatus as keyof typeof AssetConditionIconDictionary
                ]
              }
              <FormattedMessage id={`buildStatus.${props.buildStatus}`} />
            </FeatureCell>
          )}
          {props &&
            props.features &&
            Object.entries(props.features).map(
              (feature) =>
                feature[1] == 1 && (
                  <FeatureCell
                    key={feature[0]}
                    backgroundcolor="#caf0f8"
                    color="#023e8a"
                  >
                    {feature[0] in AssetFeaturesIconDictionary
                      ? AssetFeaturesIconDictionary[
                          feature[0] as keyof typeof AssetFeaturesIconDictionary
                        ]
                      : null}
                    <FormattedMessage id={`features.${feature[0]}`} />
                  </FeatureCell>
                )
            )}
        </AssetFeatures>
        <AssetProfileMaps center={defaultLocation} />
      </AssetProfileContainer>
    </HalfPageModule>
  );
}
